// extracted by mini-css-extract-plugin
export default {"profile_nickname":"ProfProfile_profile_nickname__5Iy4H","profile_text":"ProfProfile_profile_text__SzFvW"};